
import * as Blockly from 'blockly/core';
import { Colors } from '../../const';

const REUSABLE_BRICK_COLOR = Colors.REUSABLE_BRICK_COLOR; //'#138D90';
/**
 * Reusable brick block definition.
 * @type {{
*   init: Blockly.Blocks.vmt_RB_ref_no_return.init
* }}
* @this {Blockly.Block}
*/
Blockly.Blocks['vmt_RB_ref_no_return'] = {
    /**
     * Initializes the block.
     * @this {Blockly.Block}
     */
    init: function () {
        this.jsonInit({
            "message0": "%1 %2 %3 %4",
            "args0": [
                {
                    "type": "field_image",
                    "name": "ICON",
                    "src": "media/images/recycling_40dp_FFFFFF_FILL0_wght400_GRAD0_opsz40.svg",
                    "width": 30,
                    "height": 30,
                    "alt": "♻",
                    "flipRtl": "FALSE"
                },
                {
                    "type": "field_input",
                    "name": "CAPTION",
                    "text": "<caption>"
                },
                {
                    "type": "input_dummy"
                },
                {
                    "type": "input_statement",
                    "name": "PARAMETERS",
                    "check": "ParamControl"
                    // "check": ["ParamControl", "null"]
                }
            ],
            "previousStatement": ["Brick", "ReBlock", "null"],
            "nextStatement": ["Brick", "ReBlock", "null"],
            // "output": null,
            "colour": REUSABLE_BRICK_COLOR,
            "tooltip": "Reusable Block Reference",
            "helpUrl": "",
            // "extensions": ["children_blocks_extension",]
        });

        // this.getField('EXPAND_COLLAPSE').setOnClickHandler(function () {
        //     this.getSourceBlock().setCollapsed(true);
        // });
    },

    /**
     * @param {Blockly.Events.Abstract} event The change event.
     * @this {Blockly.BlockSvg}
     */
    onchange: function (event) {
        if (event.type === Blockly.Events.BLOCK_CREATE && this.id === event.blockId) {
            const paramsInput = this.getInput('PARAMETERS');
            if (paramsInput?.connection.targetBlock() === null) {
                this.removeInput('PARAMETERS', /* no error */ true);
            }
        }
    },
};

Blockly.Extensions.register(
    'children_blocks_extension',
    function () { // this refers to the block that the extension is being run on
        const parentBlock = this.getSurroundParent();
        console.log('>>>children_blocks_extension', this.type, this.id, parentBlock);
        // const paramsInput = parentBlock.getInput('PARAMETERS');
        // let paramBlock = paramsInput.connection.targetBlock();
        // while (paramBlock) {
        //     console.log('>>>paramBlock', paramBlock.type, paramBlock.getFieldValue('PARAM_NAME'));
        //     // if (paramBlock.type === 'vmt_RB_param_control') {
        //     //     const paramName = paramBlock.getFieldValue('PARAM_NAME');
        //     // }
        //     paramBlock = paramBlock.getNextBlock();
        // }
    });

const vmtControlJson = {
    "message0": "%1 %2 %3 %4",
    "args0": [
        {
            "type": "field_image",
            "src": "media/images/settop_component_40dp_FFFFFF_FILL0_wght400_GRAD0_opsz40.svg",
            "width": 30,
            "height": 30,
            "alt": "#",
        },
        {
            "type": "field_label_serializable",
            "name": "PARAM_NAME",
            "text": "Param"
        },
        {
            "type": "field_label_serializable",
            "name": "INDENT",
            "text": ""
        },
        {
            "type": "input_value",
            "name": "VALUE",
            "check": ["String", "Number", "Boolean", "null"]
        }
    ],
    "previousStatement": "ParamControl",
    "nextStatement": "ParamControl",
    // "previousStatement": null,
    // "nextStatement": null,
    "colour": REUSABLE_BRICK_COLOR,
    "tooltip": "",
    "helpUrl": "",
    // "extensions": ["children_blocks_extension",]
};

Blockly.Blocks['vmt_RB_param_control'] =
    Blockly.Blocks['vmt_RB_param_control_last'] = {
        init: function () {
            this.jsonInit(vmtControlJson);
            // this.setDeletable(false);
            // this.setMovable(false);
            // this.getField('EXPAND_COLLAPSE').setOnClickHandler(function () {
            //     console.log('>>>EXPAND_COLLAPSE<<<');
            //     this.getSourceBlock().setCollapsed(true);
            // });
        },
        // onchange: function () {
        //     console.log('VMT_CONTROL changed', this);
        // }
    };
